module.exports = __webpack_public_path__ + "static/media/ic_antecedentes.5bdac1a4.svg";